import Axios from "./request"  // 导入配置好的axios文件

export function get(url, params) {
    return Axios({
        url: url,
        method: "get",
        params: params
    })
}

export function post(url, params = {}) {
    return Axios({
        url: url,
        method: "post",
        data: params,
    })
}
